<template lang="html">
<div class="screen user-subscriptions" id="first_screen">
  <div>&nbsp;</div>

  <div v-for="sub in subscriptions" class="subscriptions">
    <h2>{{ sub.plan }} unlocked</h2>
    <p>you can use button below to download app from App&nbsp;Store</p>

    <div class="apple-button-wrapper">
      <a target="_blank" :href="sub.install_url">
        <img src="/media/pulse-new/email/download-on-appstore.svg" width="200">
      </a>
    </div>

    <p class="small">
        You have subscribed at {{ sub.created_at }} with trial period until {{ sub.trial_end }}.</span><br>
        If you want to cancel subscriptions use <a href="#" @click.prevent="cancel_subscription(sub)">this link</a>.
    </p>
  </div>

  <div>&nbsp;</div>
</div>
</template>

<script>
export default {
  data() {
    return {
      subscriptions: []
    }
  },
  methods: {
    init(subscriptions) {
      console.log('Initialized')
      this.subscriptions = subscriptions
      document.body.classList?.remove('loading')
    },
    cancel_subscription(sub) {
      this.$parent.$refs.tracker.report('cancel_subscription_click')

      if (confirm('Are you sure?')) {
        this.$parent.$refs.tracker.report('cancel_subscription_confirm')
        document.location.href = '/api/subscription/cancel/' + sub.token + '/confirm/'
      }
    }
  }
}
</script>

<style lang="sass">
.screen.user-subscriptions
  min-height: 460px

.subscriptions
  padding: 0 26px
  display: flex
  flex-direction: column
  gap: 16px

.screen h2
  text-align: center
</style>
